module.exports = __webpack_public_path__ + "static/media/TIMESBD.TTF-16-Bold.c8797fec.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./fonts/TIMESBD.TTF-16-Bold.woff
 ** module id = 11
 ** module chunks = 0
 **/